import React, { useState } from "react";
import HistoryIcon from "@mui/icons-material/History";
import pullListLabels from "../../util/PullListLabels";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { formatDateTime } from "../../util/FormUtils";

const HistoryLogElement = ({ pullLists, label }) => {
    const [open, setOpen] = useState(false);
    const changes = [];

    // Iterate over each version of an xplan, comparing it to the previous version
    for (let i = 0; i <= pullLists.length - 1; i++) {
        const currVer = pullLists[i];
        const prevVer = pullLists[i + 1];

        const currVal = currVer[label];
        const prevVal = i === pullLists.length - 1 ? null : prevVer[label];

        // If any values are different, store the changes
        if (
            i === pullLists.length ||
            ((currVal || prevVal) && currVal !== prevVal)
        ) {
            //changes += `${currVer.updatedBy} > ${currVer.updatedAt.slice(0, 16).replace("T", " ")} > ${currVal}\n`;
            if (currVer.updatedAt) {
                changes.push(
                    <div className="historyEntry historyLogEntry">
                        <div className="historyUserTime">
                            <h2 className="historyUser">{currVer.updatedBy}</h2>{" "}
                            {/*<Typography>{changes.push(currVer.updatedBy)}</Typography>*/}
                            <p className="historyTime">{formatDateTime(currVer.updatedAt)}</p>
                        </div>
                        <div className="historyContentEntry">
                            <span className="historyFieldName">
                                {`${label}`} <ArrowRightIcon style={{ fontSize: "22px" }} />
                            </span>{" "}
                            {`${currVal}`}
                        </div>
                    </div>
                );
            } else {
                changes.push(`${currVer.updatedBy} > ${currVal}`);
            }
        }
    }

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    return (
        <>
            <button onClick={handleOpen} className="historyButton">
                <HistoryIcon />
            </button>

            {open && (
                <div
                    className="historyModal"
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    onClick={handleClose}
                >
                    <div
                        className="historyBox"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <h1 id="modal-modal-title" className="historyTitle">
                            {pullListLabels[label]} History
                        </h1>
                        <div id="modal-modal-description" className="historyContent">
                            {changes.length && changes[0] ? (
                                changes.map((change, index) => <div key={index}>{change}</div>)
                            ) : (
                                <div className="historyNone">
                                    <EditNoteIcon fontSize="small" />{" "}
                                    <p>No change has been made.</p>
                                </div>
                            )}
                        </div>
                        <div className="historyButtonSection">
                            <button onClick={handleClose} className="historyCloseButton">
                                CLOSE
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HistoryLogElement;
